<ngx-slick-carousel [config]="settings" class="basic-dot-slider light-dots">
    <!-- Data -->
    <div class="slide-item" ngxSlickItem *ngFor="let item of testimonials">
        <p class="mb-0">{{item.comment}}</p>
    </div>
    <!-- Data -->
</ngx-slick-carousel>